import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

function PricingPlans() {
  const plans = [
    {
      label: '超早割',
      discount: '25%OFF',
      limit: '限定150名',
      price: '一般販売予定価格より25%OFF',
      features: ['Atelier Folio for iPad 1点', '同色ペンホルダー1個付属', 'Makuake限定カラー選択可'],
      accent: '#E53935',
      popular: true,
    },
    {
      label: '早割',
      discount: '20%OFF',
      limit: '限定350名',
      price: '一般販売予定価格より20%OFF',
      features: ['Atelier Folio for iPad 1点', '同色ペンホルダー1個付属', 'Makuake限定カラー選択可'],
      accent: '#C8956C',
      popular: false,
    },
    {
      label: 'Makuake限定',
      discount: 'セット割',
      limit: '数量限定',
      price: '追加ペンホルダーセット',
      features: ['本体1点', '付属ペンホルダー1個', '追加ペンホルダー1個'],
      accent: '#8B6BAE',
      popular: false,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
      {plans.map((plan, index) => (
        <div
          key={index}
          className={`relative bg-white rounded-2xl border-2 p-6 transition-all hover:shadow-lg ${
            plan.popular ? 'border-[#E53935] shadow-[0_4px_24px_rgba(229,57,53,0.1)]' : 'border-[#E8E8E8]'
          }`}
        >
          {plan.popular && (
            <div className="absolute -top-3 left-1/2 -translate-x-1/2">
              <span className="inline-flex items-center gap-1 px-4 py-1 bg-[#E53935] text-white text-xs font-bold rounded-full whitespace-nowrap">
                <i className="ri-fire-fill text-[#FFD54F] text-xs"></i>
                最もお得
              </span>
            </div>
          )}
          <div className="text-center mb-5 pt-2">
            <span
              className="inline-block text-xs font-bold tracking-wider px-3 py-1 rounded-full mb-3"
              style={{ backgroundColor: `${plan.accent}15`, color: plan.accent }}
            >
              {plan.label}
            </span>
            <div
              className="text-3xl font-black mb-1"
              style={{ color: plan.accent, fontFamily: 'Playfair Display, serif' }}
            >
              {plan.discount}
            </div>
            <span
              className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-0.5 rounded-full bg-[#FFF3E0] text-[#E65100]"
            >
              <i className="ri-group-line text-xs"></i>
              {plan.limit}
            </span>
          </div>
          <div className="border-t border-[#F0F0F0] pt-4 mb-4">
            <p className="text-sm text-[#6B6B6B] text-center mb-3">{plan.price}</p>
            <ul className="space-y-2">
              {plan.features.map((feature, fi) => (
                <li key={fi} className="flex items-start gap-2 text-sm text-[#4A4A4A]">
                  <i className="ri-check-line text-sm mt-0.5 flex-shrink-0" style={{ color: plan.accent }}></i>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
}

function ExclusiveContent() {
  const contents = [
    {
      icon: 'ri-palette-line',
      title: '限定カラー先行公開',
      desc: 'LINE登録者だけに、Makuake限定カラーの詳細を公開前にお届けします。一般公開では見られない特別なカラーバリエーションをいち早くチェック。',
      accent: '#8B6BAE',
    },
    {
      icon: 'ri-vidicon-line',
      title: '開発ストーリー動画',
      desc: '9段階の角度設計がどのように生まれたのか。医学的根拠に基づく設計プロセスの裏側を、開発者自らが語る限定動画をお届けします。',
      accent: '#C8956C',
    },
    {
      icon: 'ri-coupon-3-line',
      title: 'LINE限定クーポン',
      desc: 'Makuake公開日に使える、LINE登録者限定の追加割引クーポンを配布予定。超早割と組み合わせてさらにお得に。',
      accent: '#E53935',
    },
    {
      icon: 'ri-user-star-line',
      title: 'プロクリエイターレビュー',
      desc: 'プロのイラストレーター・デザイナーによる先行レビューを、LINE登録者限定で先行公開。実際の使用感をリアルにお届けします。',
      accent: '#4A8B3F',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {contents.map((item, index) => (
        <div
          key={index}
          className="bg-white rounded-xl border border-[#E8E8E8] p-5 hover:shadow-md transition-all group"
        >
          <div className="flex items-start gap-4">
            <div
              className="w-11 h-11 flex-shrink-0 rounded-xl flex items-center justify-center transition-transform group-hover:scale-110"
              style={{ backgroundColor: `${item.accent}12` }}
            >
              <i className={`${item.icon} text-xl`} style={{ color: item.accent }}></i>
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-bold text-[#2C2C2C] mb-1.5">{item.title}</h4>
              <p className="text-xs text-[#6B6B6B] leading-relaxed">{item.desc}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default function ThanksPage() {
  const [isVisible, setIsVisible] = useState(false);
  const [checkVisible, setCheckVisible] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setCheckVisible(true), 200);
    const t2 = setTimeout(() => setIsVisible(true), 500);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  const steps = [
    {
      num: '01',
      icon: 'ri-check-double-line',
      title: 'LINE登録完了',
      desc: '優先案内リストに登録されました',
      accent: '#06C755',
    },
    {
      num: '02',
      icon: 'ri-notification-3-line',
      title: '公開3日前に通知',
      desc: 'Makuake公開日時・早割価格をLINEでお届け',
      accent: '#C8956C',
    },
    {
      num: '03',
      icon: 'ri-rocket-line',
      title: '公開日に最速で支援',
      desc: '超早割25%OFFを確実にゲット',
      accent: '#E53935',
    },
  ];

  return (
    <div className="min-h-screen bg-[#FAFAF8]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      {/* ナビバー */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/a6432ee4b37c265c1d5171353c491488.png"
              alt="Atelier Folio"
              className="h-9 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="text-sm text-[#6B6B6B] hover:text-[#2C2C2C] transition-colors cursor-pointer flex items-center gap-1"
          >
            <i className="ri-arrow-left-s-line text-base"></i>
            トップに戻る
          </Link>
        </div>
      </nav>

      {/* メインコンテンツ */}
      <main className="pt-24 pb-20 px-6">
        {/* サンクスメッセージ */}
        <section className="max-w-2xl mx-auto text-center mb-16">
          <div
            className={`mx-auto mb-8 w-24 h-24 rounded-full bg-[#06C755]/10 flex items-center justify-center transition-all duration-700 ${
              checkVisible ? 'scale-100 opacity-100' : 'scale-50 opacity-0'
            }`}
          >
            <div className="w-16 h-16 rounded-full bg-[#06C755] flex items-center justify-center shadow-[0_8px_32px_rgba(6,199,85,0.3)]">
              <i className="ri-check-line text-white text-3xl"></i>
            </div>
          </div>

          <div
            className={`transition-all duration-700 delay-300 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'
            }`}
          >
            <h1
              className="text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              ご登録ありがとうございます！
            </h1>
            <p className="text-base text-[#6B6B6B] leading-relaxed">
              LINE公式アカウントへの登録が完了しました。
              <br />
              <strong className="text-[#2C2C2C]">Makuake公開日の優先案内</strong>をお届けします。
            </p>
          </div>
        </section>

        {/* 優先案内の価値を強調 */}
        <section
          className={`max-w-3xl mx-auto mb-16 transition-all duration-700 delay-500 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <div className="bg-white rounded-2xl border border-[#E8E8E8] shadow-[0_4px_24px_rgba(0,0,0,0.04)] overflow-hidden">
            <div className="bg-gradient-to-r from-[#2C2C2C] to-[#3D3D3D] px-8 py-6 text-center">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/10 rounded-full mb-3">
                <i className="ri-vip-crown-2-line text-[#C8956C] text-sm"></i>
                <span className="text-xs text-white/90 font-medium tracking-wider">PRIORITY ACCESS</span>
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
                あなたは<span className="text-[#C8956C]">優先案内リスト</span>に登録されました
              </h2>
              <p className="text-sm text-white/70 mt-2">
                Makuake公開日に、誰よりも早く情報をお届けします
              </p>
            </div>

            <div className="px-8 py-8">
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-[#E53935]/10 flex items-center justify-center">
                    <i className="ri-timer-flash-line text-lg text-[#E53935]"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-[#2C2C2C] mb-1">公開日時を最速でお知らせ</h3>
                    <p className="text-sm text-[#6B6B6B] leading-relaxed">
                      Makuakeプロジェクト公開の<strong className="text-[#E53935]">3日前</strong>にLINEで通知。開始時刻を事前に把握できます。
                    </p>
                  </div>
                </div>

                <div className="border-t border-[#F0F0F0]"></div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-[#C8956C]/10 flex items-center justify-center">
                    <i className="ri-price-tag-3-line text-lg text-[#C8956C]"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-[#2C2C2C] mb-1">早割価格を先行公開</h3>
                    <p className="text-sm text-[#6B6B6B] leading-relaxed">
                      <strong className="text-[#E53935]">超早割25%OFF（限定150名）</strong>・<strong className="text-[#C8956C]">早割20%OFF（限定350名）</strong>の詳細を、一般公開前にお届けします。
                    </p>
                  </div>
                </div>

                <div className="border-t border-[#F0F0F0]"></div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-[#06C755]/10 flex items-center justify-center">
                    <i className="ri-gift-line text-lg text-[#06C755]"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-[#2C2C2C] mb-1">LINE登録者限定の特典</h3>
                    <p className="text-sm text-[#6B6B6B] leading-relaxed">
                      限定カラー先行公開・追加割引クーポン・開発ストーリー動画など、LINE登録者だけの特別コンテンツをお届けします。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 早割プラン詳細 */}
        <section
          className={`max-w-4xl mx-auto mb-16 transition-all duration-700 delay-[600ms] ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#E53935]/8 rounded-full mb-4">
              <i className="ri-fire-fill text-[#E53935] text-sm"></i>
              <span className="text-xs font-bold text-[#E53935] tracking-wider">EARLY BIRD PLANS</span>
            </div>
            <h2
              className="text-2xl md:text-3xl font-bold text-[#2C2C2C] mb-2"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              早割プランの<span className="text-[#E53935]">ご案内</span>
            </h2>
            <p className="text-sm text-[#6B6B6B]">
              LINE登録者には公開前に詳細価格をお届けします
            </p>
          </div>

          <PricingPlans />

          <div className="mt-6 space-y-3">
            <div className="text-center">
              <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#FFF8E1] rounded-xl border border-[#FFE082]">
                <i className="ri-alarm-warning-line text-[#F57F17] text-base"></i>
                <p className="text-sm text-[#5D4037]">
                  <strong>超早割は150名限定</strong>です。公開直後に売り切れが予想されます。LINE通知で開始時刻を確認し、最速で支援しましょう。
                </p>
              </div>
            </div>
            <div className="text-center">
              <div className="inline-flex items-start gap-2 px-4 py-2 bg-[#F5F5F5] rounded-lg border border-[#E0E0E0]">
                <i className="ri-information-line text-[#757575] text-sm mt-0.5 flex-shrink-0"></i>
                <div className="text-xs text-[#616161] text-left">
                  <p>※ 重量はペンケースを含んだ重さです。</p>
                  <p>※ 多少の誤差はあります。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* LINE登録者限定コンテンツ */}
        <section
          className={`max-w-4xl mx-auto mb-16 transition-all duration-700 delay-[700ms] ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#8B6BAE]/8 rounded-full mb-4">
              <i className="ri-star-line text-[#8B6BAE] text-sm"></i>
              <span className="text-xs font-bold text-[#8B6BAE] tracking-wider">EXCLUSIVE CONTENT</span>
            </div>
            <h2
              className="text-2xl md:text-3xl font-bold text-[#2C2C2C] mb-2"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              LINE登録者<span className="text-[#8B6BAE]">限定</span>コンテンツ
            </h2>
            <p className="text-sm text-[#6B6B6B]">
              公開日までに順次お届けする特別な情報です
            </p>
          </div>

          <ExclusiveContent />
        </section>

        {/* ステップタイムライン */}
        <section
          className={`max-w-4xl mx-auto mb-16 transition-all duration-700 delay-[800ms] ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <h2
            className="text-center text-2xl font-bold text-[#2C2C2C] mb-10"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            今後の<span className="text-[#8B6BAE]">流れ</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {steps.map((step, index) => (
              <div
                key={index}
                className="relative bg-white rounded-2xl border border-[#E8E8E8] p-7 text-center hover:shadow-lg transition-shadow duration-300"
              >
                <div
                  className="text-xs font-bold tracking-widest mb-4"
                  style={{ color: step.accent, fontFamily: 'Playfair Display, serif' }}
                >
                  STEP {step.num}
                </div>

                <div
                  className="w-14 h-14 mx-auto mb-4 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: `${step.accent}15` }}
                >
                  <i className={`${step.icon} text-2xl`} style={{ color: step.accent }}></i>
                </div>

                <h3 className="text-base font-bold text-[#2C2C2C] mb-2">{step.title}</h3>
                <p className="text-sm text-[#6B6B6B] leading-relaxed">{step.desc}</p>

                {index < steps.length - 1 && (
                  <div className="hidden md:flex absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-6 h-6 items-center justify-center bg-white rounded-full border border-[#E8E8E8]">
                    <i className="ri-arrow-right-s-line text-sm text-[#9B9B9B]"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* 通知設定の案内 */}
        <section
          className={`max-w-xl mx-auto mb-16 transition-all duration-700 delay-[900ms] ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <div className="bg-gradient-to-br from-[#06C755] to-[#04A847] rounded-2xl p-8 text-center text-white shadow-[0_8px_32px_rgba(6,199,85,0.2)]">
            <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-white/20 flex items-center justify-center">
              <i className="ri-notification-3-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold mb-2">通知を見逃さないために</h3>
            <p className="text-sm text-white/85 leading-relaxed mb-6">
              LINE通知をオンにして、Makuake公開日の
              <br />
              優先案内を確実に受け取りましょう。
            </p>
            <div className="bg-white/15 backdrop-blur-sm rounded-xl p-5 text-left space-y-3">
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex-shrink-0 rounded-full bg-white/20 flex items-center justify-center text-xs font-bold">1</span>
                <p className="text-sm text-white/90">LINEアプリで「Atelier Folio」のトーク画面を開く</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex-shrink-0 rounded-full bg-white/20 flex items-center justify-center text-xs font-bold">2</span>
                <p className="text-sm text-white/90">右上のメニュー（≡）から「通知」をオンに設定</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 flex-shrink-0 rounded-full bg-white/20 flex items-center justify-center text-xs font-bold">3</span>
                <p className="text-sm text-white/90">公開日の優先案内が届くのをお待ちください</p>
              </div>
            </div>
          </div>
        </section>

        {/* 製品プレビュー＋ホームへ戻る */}
        <section
          className={`max-w-3xl mx-auto text-center transition-all duration-700 delay-[1100ms] ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <div className="bg-white rounded-2xl border border-[#E8E8E8] overflow-hidden">
            <div className="relative w-full h-64 md:h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/f4f7a23f3dba258f865f0b7dfa3d84a8.jpg"
                alt="Atelier Folio for iPad"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent"></div>
            </div>
            <div className="px-8 pb-8 -mt-8 relative">
              <h3
                className="text-xl font-bold text-[#2C2C2C] mb-2"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                Atelier Folio for iPad
              </h3>
              <p className="text-sm text-[#6B6B6B] mb-6">
                描く人のために設計された、唯一のモバイルiPadケーススタンド。
                <br />
                医学的に推奨される9段階の角度設計で、あなたの創作を支えます。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-[#2C2C2C] text-white text-sm font-medium rounded-full hover:bg-[#1A1A1A] transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-home-4-line text-base"></i>
                  トップページを見る
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* フッター */}
      <footer className="py-8 px-6 bg-[#2C2C2C]">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">&copy; 2025 Atelier Folio. All rights reserved.</p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/30 hover:text-white/50 transition-colors text-sm cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </footer>
    </div>
  );
}
